// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W2W1NM2NxigpeVgHIS5l{border-top:1px solid var(--background-neutral-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `W2W1NM2NxigpeVgHIS5l`
};
export default ___CSS_LOADER_EXPORT___;
